export default __webpack_public_path__ + "static/media/certi_ss.f1206cbd.png";